module.exports = __webpack_public_path__ + "static/media/icon_57.4d30d896.svg";